// extracted by mini-css-extract-plugin
export default {"multiline-text":"merge-code__multiline-text--grzzN","multilineText":"merge-code__multiline-text--grzzN"};